import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getWebhookDeliveries } from "../../api/apiWebhooks";

export const useGetWebhookDeliveries = (webhookId, params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["webhook-deliveries", webhookId, params, i18next.language],
        queryFn: () => getWebhookDeliveries(webhookId, params),
        enabled: Boolean(webhookId),
        keepPreviousData: true,
    });

    const list = Array.isArray(data) ? data : (data?.data ?? []);
    const deliveries = Array.isArray(list) ? list : [];
    const meta = data?.meta || {
        current_page: 1,
        per_page: params?.per_page || 50,
        total: deliveries.length,
    };

    return { deliveries, meta, isLoading, error, refetch };
};
